var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME, USE_LIST_PLAYERS_BY_TEAM_ID, USE_RETRIEVE_TEAMS_BY_PLAYER_ID, } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_PLAYER_FEED, USE_RETRIEVE_TEAM_FEED } from "./queryKeys";
var USE_LIST_MY_INVITATIONS = "useListMyInvitations";
var USE_LIST_TEAM_INVITATIONS = "useListTeamInvitations";
var USE_RETRIEVE_INVITATION = "useRetrieveInvitation";
var USE_RETRIEVE_TEAM_INVITE_LINK = "useRetrieveTeamInviteLink";
var USE_PREVIEW_INVITE_LINK = "usePreviewInviteLink";
var USE_PREVIEW_INVITATION_BY_TOKEN = "usePreviewInvitationByToken";
var USE_SEARCH_INVITABLE_PLAYERS = "useSearchInvitablePlayers";
// League-team invitation query keys
var USE_LIST_MY_LEAGUE_TEAM_INVITATIONS = "useListMyLeagueTeamInvitations";
var USE_LIST_LEAGUE_INVITATIONS = "useListLeagueInvitations";
var USE_RETRIEVE_LEAGUE_TEAM_INVITATION = "useRetrieveLeagueTeamInvitation";
var USE_SEARCH_INVITABLE_TEAMS = "useSearchInvitableTeams";
// Team ownership invitation query keys
var USE_LIST_MY_OWNERSHIP_INVITATIONS = "useListMyOwnershipInvitations";
var USE_LIST_TEAM_OWNERSHIP_INVITATIONS = "useListTeamOwnershipInvitations";
var USE_RETRIEVE_OWNERSHIP_INVITATION = "useRetrieveOwnershipInvitation";
var USE_PREVIEW_OWNERSHIP_BY_TOKEN = "usePreviewOwnershipByToken";
var USE_LIST_MERGEABLE_TEAMS = "useListMergeableTeams";
var USE_SEARCH_OWNERSHIP_INVITABLE_USERS = "useSearchOwnershipInvitableUsers";
export var useRetrieveTeamInviteLink = function (_a) {
    var teamId = _a.teamId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_TEAM_INVITE_LINK, teamId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/teams/".concat(teamId, "/invite-link/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!teamId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        retry: false,
    });
};
export var useListMyInvitations = function () {
    return useQuery({
        queryKey: [USE_LIST_MY_INVITATIONS],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-player/my-invitations/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveInvitation = function (_a) {
    var id = _a.id;
    return useQuery({
        queryKey: [USE_RETRIEVE_INVITATION, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-player/".concat(id, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!id,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListTeamInvitations = function (_a) {
    var teamId = _a.teamId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_TEAM_INVITATIONS, teamId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/teams/".concat(teamId, "/list-invitations/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!teamId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useCreateTeamPlayerInvitation = function (_a) {
    var teamId = _a.teamId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/teams/".concat(teamId, "/invitations/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_TEAM_INVITATIONS, teamId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useProcessInvitation = function (_a) {
    var invitation = _a.invitation, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/invitations/team-player/process/".concat(invitation.id, "/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_MY_INVITATIONS]);
            queryClient.invalidateQueries([USE_RETRIEVE_INVITATION, invitation.id]);
            queryClient.invalidateQueries([
                USE_LIST_PLAYERS_BY_TEAM_ID,
                invitation.team,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAMS_BY_PLAYER_ID]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_FEED, invitation.team]);
            queryClient.invalidateQueries([USE_RETRIEVE_PLAYER_FEED]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useAcceptInvitationByToken = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var token = _b.token, status = _b.status;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.put("/invitations/team-player/accept-by-token/".concat(token, "/"), { status: status })];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_MY_INVITATIONS]);
            queryClient.invalidateQueries([
                USE_LIST_PLAYERS_BY_TEAM_ID,
                data.data.team,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAMS_BY_PLAYER_ID]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_FEED, data.data.team]);
            queryClient.invalidateQueries([USE_RETRIEVE_PLAYER_FEED]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var usePreviewInvitationByToken = function (_a) {
    var token = _a.token, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_PREVIEW_INVITATION_BY_TOKEN, token],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-player/accept-by-token/".concat(token, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!token,
        retry: false,
    });
};
export var useCancelInvitation = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var invitationId = _b.invitationId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.delete("/invitations/team-player/cancel/".concat(invitationId, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (_, variables) {
            queryClient.invalidateQueries([
                USE_LIST_TEAM_INVITATIONS,
                variables.teamId,
            ]);
            onSuccess();
        },
        onError: onError,
    });
};
export var useGenerateInviteLink = function (_a) {
    var teamId = _a.teamId, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/teams/".concat(teamId, "/invite-link/generate/"))];
            });
        }); },
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_INVITE_LINK, teamId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useRevokeInviteLink = function (_a) {
    var teamId = _a.teamId, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/teams/".concat(teamId, "/invite-link/revoke/"))];
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_INVITE_LINK, teamId]);
            onSuccess();
        },
        onError: onError,
    });
};
export var useJoinTeamByLink = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (token) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/invitations/team-links/".concat(token, "/join/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_PLAYERS_BY_TEAM_ID,
                data.data.team,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAMS_BY_PLAYER_ID]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_FEED, data.data.team]);
            queryClient.invalidateQueries([USE_RETRIEVE_PLAYER_FEED]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var usePreviewInviteLink = function (_a) {
    var token = _a.token, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_PREVIEW_INVITE_LINK, token],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-links/".concat(token, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!token,
    });
};
export var useSearchInvitablePlayers = function (_a) {
    var teamId = _a.teamId, searchTerm = _a.searchTerm, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_SEARCH_INVITABLE_PLAYERS, teamId, searchTerm],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/teams/".concat(teamId, "/players/invitable/"), { params: __assign({}, (searchTerm ? { q: searchTerm } : {})) })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!teamId,
    });
};
export var useSearchOwnershipInvitableUsers = function (_a) {
    var teamId = _a.teamId, searchTerm = _a.searchTerm, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_SEARCH_OWNERSHIP_INVITABLE_USERS, teamId, searchTerm],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/teams/".concat(teamId, "/users/ownership-invitable/"), { params: __assign({}, (searchTerm ? { q: searchTerm } : {})) })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!teamId,
    });
};
// ──────────────────────────────────────────────
// League-Team Invitation hooks
// ──────────────────────────────────────────────
export var useListMyLeagueTeamInvitations = function () {
    return useQuery({
        queryKey: [USE_LIST_MY_LEAGUE_TEAM_INVITATIONS],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/league-team/my-invitations/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveLeagueTeamInvitation = function (_a) {
    var id = _a.id;
    return useQuery({
        queryKey: [USE_RETRIEVE_LEAGUE_TEAM_INVITATION, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/league-team/".concat(id, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!id,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListLeagueInvitations = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_LEAGUE_INVITATIONS, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/invitations/list/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useSearchInvitableTeams = function (_a) {
    var leagueId = _a.leagueId, searchTerm = _a.searchTerm, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_SEARCH_INVITABLE_TEAMS, leagueId, searchTerm],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/teams/invitable/"), {
                            params: __assign({}, (searchTerm ? { q: searchTerm } : {})),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!leagueId,
    });
};
export var useCreateLeagueTeamInvitation = function (_a) {
    var leagueId = _a.leagueId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/leagues/".concat(leagueId, "/invitations/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_LEAGUE_INVITATIONS, leagueId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useProcessLeagueTeamInvitation = function (_a) {
    var invitation = _a.invitation, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/invitations/league-team/process/".concat(invitation.id, "/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_MY_LEAGUE_TEAM_INVITATIONS]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_LEAGUE_TEAM_INVITATION,
                invitation.id,
            ]);
            queryClient.invalidateQueries([
                USE_LIST_LEAGUE_INVITATIONS,
                invitation.league,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useCancelLeagueTeamInvitation = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var invitationId = _b.invitationId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.delete("/invitations/league-team/cancel/".concat(invitationId, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (_, variables) {
            queryClient.invalidateQueries([
                USE_LIST_LEAGUE_INVITATIONS,
                variables.leagueId,
            ]);
            onSuccess();
        },
        onError: onError,
    });
};
// ──────────────────────────────────────────────
// Team Ownership Invitation hooks
// ──────────────────────────────────────────────
export var useListMyOwnershipInvitations = function () {
    return useQuery({
        queryKey: [USE_LIST_MY_OWNERSHIP_INVITATIONS],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-ownership/my-invitations/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveOwnershipInvitation = function (_a) {
    var id = _a.id;
    return useQuery({
        queryKey: [USE_RETRIEVE_OWNERSHIP_INVITATION, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-ownership/".concat(id, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!id,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListTeamOwnershipInvitations = function (_a) {
    var teamId = _a.teamId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_TEAM_OWNERSHIP_INVITATIONS, teamId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/teams/".concat(teamId, "/ownership-invitations/list/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!teamId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListMergeableTeams = function (_a) {
    var invitationId = _a.invitationId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_MERGEABLE_TEAMS, invitationId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-ownership/".concat(invitationId, "/mergeable-teams/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!invitationId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useCreateOwnershipInvitation = function (_a) {
    var teamId = _a.teamId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/teams/".concat(teamId, "/ownership-invitations/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_TEAM_OWNERSHIP_INVITATIONS,
                teamId,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useProcessOwnershipInvitation = function (_a) {
    var invitation = _a.invitation, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/invitations/team-ownership/process/".concat(invitation.id, "/"), payload)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_MY_OWNERSHIP_INVITATIONS]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_OWNERSHIP_INVITATION,
                invitation.id,
            ]);
            queryClient.invalidateQueries([
                USE_LIST_TEAM_OWNERSHIP_INVITATIONS,
                invitation.team,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAMS_BY_PLAYER_ID]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var usePreviewOwnershipByToken = function (_a) {
    var token = _a.token, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_PREVIEW_OWNERSHIP_BY_TOKEN, token],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/invitations/team-ownership/accept-by-token/".concat(token, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        enabled: enabled && !!token,
        retry: false,
    });
};
export var useAcceptOwnershipByToken = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var token = _b.token, status = _b.status, mergeIntoTeamId = _b.mergeIntoTeamId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.put("/invitations/team-ownership/accept-by-token/".concat(token, "/"), __assign({ status: status }, (mergeIntoTeamId ? { mergeIntoTeamId: mergeIntoTeamId } : {})))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_LIST_MY_OWNERSHIP_INVITATIONS]);
            queryClient.invalidateQueries([USE_RETRIEVE_TEAMS_BY_PLAYER_ID]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useCancelOwnershipInvitation = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var invitationId = _b.invitationId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.delete("/invitations/team-ownership/cancel/".concat(invitationId, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (_, variables) {
            queryClient.invalidateQueries([
                USE_LIST_TEAM_OWNERSHIP_INVITATIONS,
                variables.teamId,
            ]);
            onSuccess();
        },
        onError: onError,
    });
};
